import { render, staticRenderFns } from "./imageData.vue?vue&type=template&id=356d0a16&scoped=true&"
import script from "./imageData.vue?vue&type=script&lang=js&"
export * from "./imageData.vue?vue&type=script&lang=js&"
import style0 from "./imageData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./imageData.vue?vue&type=style&index=1&id=356d0a16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356d0a16",
  null
  
)

component.options.__file = "imageData.vue"
export default component.exports